



















import LoginModal from '@/components/modals/login'
import ContributeModal from '@/components/modals/contribute'
import PasswordModal from '@/components/modals/password'
import PrivateModal from '@/components/modals/private'
import AppMarketUpdateModal from '@/components/modals/app-market-update'
import NewsModal from '@/components/modals/news'

export default {
  name: 'modal-dialog',
  components: {
    LoginModal,
    ContributeModal,
    PasswordModal,
    PrivateModal,
    AppMarketUpdateModal,
    NewsModal
  },
  data() {
    return {
    }
  },
  computed: {
    modal() {
      return this.$store.state.runtime.modal
    },
    loading() {
      return this.$store.state.runtime.modalIsLoading
    },
    private() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    }
  },
  watch: {
    private(isPrivate, wasPrivate) {
      if (isPrivate && !wasPrivate) {
        this.$store.dispatch('runtime/showModal', 'private')
      } else if (this.modal === 'private') {
        this.$store.dispatch('runtime/closeModal')
      }
    }
  },
  created() {
  },
  mounted() {
    if (new Date(this.$store.state.persistent.dissmissedNews) < new Date('2022-05-20T19:00:00Z')) {
      this.$store.dispatch('runtime/showModal', 'news')
    }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/modal-dialog.vue